import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    gridContainer: {
        width: '100%',
    },
    selectInput: {
        width: '100%',
    },
    textField: {
        width: '100%',
    },
}));

